import makeStyles from '@mui/styles/makeStyles';

const usePlantMapViewStyles = makeStyles({
  root: {
    "& MuiPickersDay-daySelected": {
      backgroundColor: "white",
      boxShadow: "4px 4px 15px rgba(0, 0, 0, 0.05)",
      borderRadius: "50px",
      border: "none",
      "&:hover": {
        backgroundColor: "white",
        border: "none",
      },
    },
    "& .MuiInputBase-root": {
      color: "#000",
      backgroundColor: "transparent",
      borderRadius: "50px",
      border: "none",
    },
    "& MuiPickersDay-daySelected": {
      backgroundColor: "white",
      border: "none",
      "&:hover": {
        backgroundColor: "white",
        border: "none",
      },
    },
  },
  datePicker: {
    color: "#000",
    backgroundColor: "white",
    border: "none",
    boxShadow: "1px 4px 15px rgba(0, 0, 0, 0.05)",

    "& .MuiOutlinedInput-root": {
      border: "none",
      height: "48px",
      width: "200px",
    },
    "& .MuiOutlinedInput-input": {
      border: "none",
      padding: "10px",
    },
  },
});

export default usePlantMapViewStyles;
